<!-- 计划外访视填写框 -->
<script setup>
import { ref, reactive, watch , computed,toRefs } from "vue";

import { useCrfStore } from "@/stores/crf";
import TGJC from "@/components/TGJC.vue";
import BS from "@/components/BS.vue";
import YBXX from "@/components/YBXX.vue";
import FSXX from "@/components/FSXX.vue";
import XCGJNCG from "@/components/XCGJNCG.vue";
import NXGN from "@/components/NXGN.vue";
import XSHJC from "@/components/XSHJC.vue";
import AFP from "@/components/AFP.vue";
import YGHCVHIV from "@/components/YGHCVHIV.vue";
import ANAANCA from "@/components/ANAANCA.vue";
import MYQDB from "@/components/MYQDB.vue";
import JZXGN from "@/components/JZXGN.vue";
import XDT from "@/components/XDT.vue";
import WJ from "@/components/WJ.vue";
import FIBROSCAN from "@/components/FIBROSCAN.vue";
import FIBROTOUCH from "@/components/FIBROTOUCH.vue";
import FBFSMJMBC from "@/components/FBFSMJMBC.vue";
import FBCT from "@/components/FBCT.vue";
import MJMCTV from "@/components/MJMCTV.vue";
import GZZQMR from "@/components/GZZQMR.vue";
import MRCP from "@/components/MRCP.vue";
import HVPGCD from "@/components/HVPGCD.vue";
import BFXY from "@/components/BFXY.vue";
import QTBSZL from "@/components/QTBSZL.vue";
import JWTIPSZL from "@/components/JWTIPSZL.vue";
import JWWKSSZL from "@/components/JWWKSSZL.vue";
import JWNJZL from "@/components/JWNJZL.vue";
import JWYWZL from "@/components/JWYWZL.vue";
import GZSDC from "@/components/GZSDC.vue";
import QWXZJYCX from "@/components/QWXZJYCX.vue";
import BLSJJL from "@/components/BLSJJL.vue";
import GZZQCT from  "@/components/GZZQCT.vue";
import BLBG from  "@/components/BLBG.vue";

import { useUserStore } from '../stores/user'
import { ElMessage } from "element-plus"
import { useCommonStore } from "@/stores/common";


// const emits = defineEmits(["update"]);
const emits = defineEmits(["create", "open", "close", "update",'renewdate']);

const props = defineProps({
    id:'',
    planname:'',
    show:{
        type:Boolean,
        default: false
    }

});
console.log(props,'props')
let drawerShow = ref(props.show)

watch(props.show,(newval,oldval)=>{
    drawerShow.value = newval
    console.log('newval', newval)
})
// 拿到医生id
const userId = useUserStore()
console.log(userId.id,"id");

let jhw = []
const crfStore = useCrfStore();
console.log(crfStore.forms[3],"新建计划外访视")
let module = crfStore.forms[3].moduleOld;
console.log(module,"module")


// 提交上传中提示
let crfLoading = ref(false)

// 还要拿到医生的id，要通过患者的id然后拿到患者所有数据

const model = reactive({
    user_id:userId.id,
    id: props.id,
    fields: {},
    checkdata:{},

})


 // 正常点击和跳转都需要请求(患者最新的数据)
 const commonStore = useCommonStore();
    commonStore.getData(props.id).then((res) => {
      console.log(res.data,"crf往下传递的数据");
      model.id = res.data.id;
      model.fields = res.data.fields;
       // 强制所有数据都启用核查和二次核查（包括老数据）
       model.fields.ischeck = '是'
       model.fields.ischeck2 = '是'
       model.checkdata.ischeck ='是';
      // debugger
      // console.log(res.data.fields.jhw,"个人");
      // jhw = res.data.fields.jhw
      res.data.fields?.jhw?.forEach(element => {
        jhw.push(element)
      });
      console.log(jhw,"先打印");
    });
// 选择的访视日期
let date = ref('')

// type  第几个计划外访视

let type = ref('')

let componentsShow = ref(false)
watch(date,(newval,oldval)=>{
    // model.fields[`计划外${date.value}`]?model.fields[`计划外${date.value}`]['访视日期'] = '' : '';
    model.fields[`计划外${date.value}`]?.['访视日期']? model.fields[`计划外${date.value}`]['访视日期'] = newval :model.fields[`计划外${date.value}`] = {'访视日期' : newval}
   
    type.value = `计划外${date.value}`
    console.log(newval)
    // 清空上个日期选择的值
    emits('renewdate',newval)
    // 所有组件重新加载，
    componentsShow.value = false
    componentsShow.value = true


})
// 关闭
const handleCloseDrawer = ()=>{
  emits('close')
}

let IdCard = ref()
 // 提交表单
 const submitForm = async () => {
  if (!date.value) return ElMessage.error('请填写访视日期')
  // 验证手机号
 if(!IdCard.value.phonefun()) return

    const store = useCrfStore();

      // 应该拿到网上的全的数据，而不应该从本地拿（吃完饭回来改）

   
    jhw.push({
      module:[...module],
        name: '计划外'+date.value,
        type: '计划外'+date.value,
    })
    // console.log(jhw,"结构")
    jhw.sort((a,b)=>{
      // localeCompare 字符串的对比方法,按日期排序
      return a.name.localeCompare(b.name);
    })
    model.fields.jhw = jhw
    crfLoading.value = true 
    let res = await store.update(model)
    // 请求返回结果就关闭上传提示
    crfLoading.value = false 
    if (res.result != "success"){
        console.log(2222);
        return ElMessage.error('提交失败！')
    } 
    // 在主页面刷新数据
    emits("update");
}

const screen = reactive({
  size :80,
  rowWidth : '',
  colsapn :'',
  labelWidth : ''
})


//  根据屏幕的大小设置弹窗和表格的大小
const watchWindowSize = ()=>{

// 获取窗口的宽度和高度，不包括滚动条
var w = document.documentElement.clientWidth;
var h = document.documentElement.clientHeight;
// 打印结果
// result.innerHTML = "宽: " + w + ", " + "高: " + h

if (w > 1000) {
  // 弹窗的宽度设置80% 否则100%
  screen.size = 80
  screen.rowWidth = 100
  screen.colsapn= 15
  screen.labelWidth = 250
}else{
  screen.size = 100
  screen.rowWidth = 120
  screen.colsapn = 24
  screen.labelWidth = 160
}

}
watchWindowSize()
window.onresize = ()=>{
  watchWindowSize()

}
// 窗口变化事件
window.onload = ()=>{
watchWindowSize()
};


;

</script>
<template>
<!-- <el-drawer v-model="drawerShow" :title="`计划外（${date}）`"
             :close-on-click-modal="false" :close-on-press-escape="false" 
             @close="handleCloseDrawer" direction="rtl" size="80%" 
             @open="handleOpenDrawer"
             class="box"> -->
             <p class="pp">{{ crfFormIndex == 2? '如果筛选期和基线间隔<14天，筛选期数据可以作为基线数据使用，请点击适用筛选期数据':'' }}</p>
             <p class="pp">{{ props.tip? `说明:肝穿后${props.tip}周（或${props.tip}周内最接近的一次）`:'' }}</p>

    <el-row v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中"  :style="`width:${screen.rowWidth}%`">
      <!-- <el-col :span="13"> -->
      <el-col :span="screen.colsapn">

        <section>
          <el-form  :model="model" size="default" label-position="left" :label-width="`${screen.labelWidth}px`" ref="formRef"
                   :rules="formRule" :scroll-to-error="true"
                   :scroll-into-view-options="{ behavior: 'smooth', block: 'start', inline: 'nearest' }">
             <!-- 适用筛选期数据 -->
             <!-- <div v-if="crfFormIndex == 3">
              <button @click.prevent="btn(true)"> 适用筛选期数据</button>
              <button @click.prevent="btn(false)" style="margin-left: 20px;">不适用筛选期数据</button>
            </div> -->
            
             <!-- 访视信息 -->
             <div class="picker">
                <!-- <FSXX v-if="module.module.includes('FSXX')" :formModel="model" :type="props.type"></FSXX> -->
                <el-date-picker v-model="date"
                      type="date" placeholder="选择访视日期"
                      value-format="YYYY-MM-DD" />
                      
            </div>  
            <template v-if="componentsShow"> 
            <!-- 一般信息 -->
            <YBXX ref="IdCard"
              v-if="module.includes('YBXX') && !module.includes('InclusionCriteria') && !module.includes('ExcludeCriteria')"
              :mode="'whole'" :formModel="model" :fold="false" :foldbuttom="true" @phones="submitForm()"></YBXX>

            <!-- 一般信息（只读）-->
            <!-- <YBXX ref="IdCard"
              v-if="module.module.includes('YBXX') && (module.module.includes('InclusionCriteria') || module.module.includes('ExcludeCriteria'))"
              :mode="'part'" :readonly="true" :formModel="model"></YBXX> -->

           
            <!-- 病史 -->
            <BS v-if="module.includes('BS')" :formModel="model" :type="type" index="1" :btnshow="''"></BS>
              <h2>既往治疗</h2>
                <!-- 既往TIPS治疗 （既往门脉高压介入治疗）-->
                <JWTIPSZL v-if="module.includes('JWTIPSZL')" :formModel="model" title="门脉高压介入治疗"
                          :type="type"></JWTIPSZL>

                <!-- 既往外科手术治疗改：既往脾切除手术 -->
                <JWWKSSZL v-if="module.includes('JWWKSSZL')" :formModel="model"
                          prefix="【脾切除手术治疗】" :type="type"></JWWKSSZL>

                <!-- 既往内镜治疗 -->
                <JWNJZL v-if="module.includes('JWNJZL')" :formModel="model" prefix="【内镜治疗】"
                        :type="type"></JWNJZL>

                <!-- 既往药物治疗改：既往门脉高压药物治疗 -->
                <JWYWZL v-if="module.includes('JWYWZL')" :formModel="model" prefix="【门脉高压药物治疗】"
                        :type="type"></JWYWZL>

            <p v-if="module.includes('XCGJNCG')" class="tishi">实验室检查开始，未做的检查请填写"ND"</p>
            <!-- 血常规及尿常规 -->
            <XCGJNCG v-if="module.includes('XCGJNCG')" :formModel="model" :type="type"></XCGJNCG>

            <!-- 凝血功能 -->
            <NXGN v-if="module.includes('NXGN')" :formModel="model" :type="type"></NXGN>

            <!-- 血生化检查 -->
            <XSHJC v-if="module.includes('XSHJC')" :formModel="model" :type="type"></XSHJC>

            <!-- AFP -->
            <AFP v-if="module.includes('AFP')" :formModel="model" :type="type"></AFP>

            <!-- 乙肝 -->
            <YGHCVHIV v-if="module.includes('YGHCVHIV')" :formModel="model" :type="type"></YGHCVHIV>

            <!-- 自身免疫性肝病抗体谱 -->
            <ANAANCA v-if="module.includes('ANAANCA')" :formModel="model" :type="type"></ANAANCA>

            <!-- 免疫球蛋白定量 -->
            <MYQDB v-if="module.includes('MYQDB')" :formModel="model" :type="type"></MYQDB>

            <!-- 甲状腺功能 -->
            <JZXGN v-if="module.includes('JZXGN')" :formModel="model" :type="type"></JZXGN>

            <!-- 心电图 -->
            <XDT ref="xdt" v-if="module.includes('XDT')" :formModel="model" :type="type"></XDT>

            <!-- 胃镜 -->
            <WJ v-if="module.includes('WJ')" :formModel="model" :type="type"></WJ>

            <!-- Fibroscan -->
            <FIBROSCAN v-if="module.includes('FIBROSCAN')" :formModel="model" :type="type"></FIBROSCAN>

             <!-- FIBROTOUCH -->
            <FIBROTOUCH v-if="module.includes('FIBROTOUCH')" :formModel="model" :type="type"></FIBROTOUCH>

            <!-- 腹部、腹水及门静脉B超 -->
            <FBFSMJMBC v-if="module.includes('FBFSMJMBC')" :formModel="model" :type="type"></FBFSMJMBC>

            <!-- 肺部CT平扫（可选） -->
            <FBCT v-if="module.includes('FBCT')" :formModel="model" :type="type"></FBCT>

            <!-- 门静脉CTV -->
            <MJMCTV v-if="module.includes('MJMCTV')" :formModel="model" :type="type"></MJMCTV>

            <!-- 肝脏增强CT -->
            <GZZQCT v-if="module.includes('GZZQCT')" :formModel="model" :type="type"></GZZQCT>

            <!-- 肝脏增强MR -->
            <GZZQMR v-if="module.includes('GZZQMR')" :formModel="model" :type="type"></GZZQMR>

            <!-- MRCP（可选） -->
            <MRCP v-if="module.includes('MRCP')" :formModel="model" :type="type"></MRCP>

            <!-- HVPG测定（可选） -->
            <HVPGCD v-if="module.includes('HVPGCD')" :formModel="model" :type="type"></HVPGCD>
              
            <!-- 病理报告 -->
            <BLBG v-if="module.includes('BLBG')" :formModel="model" :type="type"></BLBG>

            <!-- 全外显子基因测序（可选）改为基因测序 -->
            <QWXZJYCX v-if="module.includes('QWXZJYCX')" :formModel="model" :type="type"></QWXZJYCX>

            <!--不良事件记录-->
            <BLSJJL v-if="module.includes('BLSJJL')" :formModel="model" :type="type"></BLSJJL>

            <!-- 备份血样（可选） -->
            <BFXY v-if="module.includes('BFXY')" :formModel="model" :type="type"></BFXY>

            </template>
            <template v-else>
              <h2>请先选择上面的访视时间  <span style="margin-left: 20px;"> ⬆</span></h2>
            </template>      
          </el-form>
        </section> 
        
      </el-col>
    </el-row>
    <div style="position: absolute;bottom: 30px;right: 18px;z-index: 10000;background-color: white;">
        <el-button type="primary" @click="Staging(formRef)">暂存</el-button>
        <el-button @click="handleCloseDrawer">取消</el-button>
        <el-button type="primary" @click="submitForm()">确定</el-button>
    </div>
    <!-- <template #footer>
      <el-button type="primary" @click="Staging(formRef)">暂存</el-button>
      <el-button @click="handleCloseDrawer">取消</el-button>
      <el-button type="primary" @click="submitForm(formRef,false)">确定</el-button>
    </template> -->
  <!-- </el-drawer> -->
</template>
<style lang="scss" scoped>
.picker{
    position:fixed;
    top:15px;
    /* left: 270px; */
    left: 655px;

}
@media screen and (max-width:1000px ) {
  .picker{
    position:fixed;
    top:60px;
    /* left: 270px; */
    left: 15px;
    z-index: 100;
    background-color: white;

  }
}

.tishi{
      font-size: 16px;
      color: rgb(240, 102, 102);
      /* padding-left: 15px; */
      margin: 0;
    }
</style>